var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M2.516 3.063 7.52 6.655a.82.82 0 0 0 .96 0l5.004-3.593M2.938 12.25h10.125c.931 0 1.687-.784 1.687-1.75v-7c0-.966-.755-1.75-1.687-1.75H2.938c-.932 0-1.688.784-1.688 1.75v7c0 .966.756 1.75 1.688 1.75"
})));
export default SvgEmail;